const NAME = 'deliveryCities';

export const FETCH_DELIVERY_CITIES_REQUESTED = `${NAME}/FETCH_DELIVERY_CITIES_REQUESTED`;
export const FETCH_DELIVERY_CITIES_RECEIVED = `${NAME}/FETCH_DELIVERY_CITIES_RECEIVED`;
export const FETCH_DELIVERY_CITIES_FAILED = `${NAME}/FETCH_DELIVERY_CITIES_FAILED`;

export const FETCH_DELIVERY_ZIPCODES_REQUESTED = `${NAME}/FETCH_DELIVERY_ZIPCODES_REQUESTED`;
export const FETCH_DELIVERY_ZIPCODES_RECEIVED = `${NAME}/FETCH_DELIVERY_ZIPCODES_RECEIVED`;
export const FETCH_DELIVERY_ZIPCODES_FAILED = `${NAME}/FETCH_DELIVERY_ZIPCODES_FAILED`;
